// extracted by mini-css-extract-plugin
export default {"img":"FixedImage_img__lqEGe","multiple":"FixedImage_multiple__WMYQo"};